import { redactRemoteLockTelemetryString } from '@/features/remotelock/telemetry'

interface SentryEventLike {
  breadcrumbs?: Array<{
    message?: string
    data?: Record<string, unknown>
  }>
  request?: {
    url?: string
    headers?: Record<string, string>
  }
  transaction?: string
}

const PUBLIC_API_TOKEN_PATH = /\/api\/v1\/public\/guest-portal\/(?!access(?:\/|$))[^/?#\s]+/gu
const PUBLIC_PAGE_TOKEN_PATH = /\/guest\/(?!access(?:\/|$))[^/?#\s]+/gu

export function redactGuestPortalUrl(value: string): string {
  return value
    .replace(PUBLIC_API_TOKEN_PATH, '/api/v1/public/guest-portal/[redacted]')
    .replace(PUBLIC_PAGE_TOKEN_PATH, '/guest/[redacted]')
}

function isPlainRecord(value: unknown): value is Record<string, unknown> {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false
  }
  const prototype = Object.getPrototypeOf(value)
  return prototype === Object.prototype || prototype === null
}

function redactStringValues(value: unknown, visited = new WeakSet<object>()): void {
  if (!value || typeof value !== 'object' || visited.has(value)) {
    return
  }
  visited.add(value)
  if (Array.isArray(value)) {
    for (const item of value) {
      redactStringValues(item, visited)
    }
    return
  }
  if (!isPlainRecord(value)) {
    return
  }
  for (const [key, item] of Object.entries(value)) {
    if (typeof item === 'string') {
      const redacted = redactRemoteLockTelemetryString(key, redactGuestPortalUrl(item))
      if (redacted !== item) {
        Reflect.set(value, key, redacted)
      }
    } else {
      redactStringValues(item, visited)
    }
  }
}

export function redactGuestPortalSentryEvent<T extends SentryEventLike>(event: T): T {
  redactStringValues(event)
  return event
}
